import { render } from "./PerformanceMarketingFaqSection.vue?vue&type=template&id=17a87ec3"
import script from "./PerformanceMarketingFaqSection.vue?vue&type=script&lang=js"
export * from "./PerformanceMarketingFaqSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__